import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { STATE__ui } from '../STATE__ui';

export const LOCAL__ui_generation_output_image_preview_set = (payload: DTO__image_asset): PayloadAction<DTO__image_asset> => ({
  type: ENUM__redux_action.UI_GENERATION_OUTPUT_IMAGE_PREVIEW_SET,
  payload,
});

export function INIT_LOCAL__ui_generation_output_image_preview_set(state: STATE__ui, action: PayloadAction<DTO__image_asset>) {
  state.g_output__image_asset_preview = action.payload.clone();
}
